<template>
    <article>
        <p>
            This inspection detects when one or more instances of an application are not available or have been restarted.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/instances.png" />
        </v-card>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
